import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useProtectedRoutes from 'routes/useProtectedRoutes';
import Header from './partials/header/Header';
import Sidebar from './partials/sidebar/Sidebar';
import { useLocation } from 'react-router-dom';
import {
  handlPlanTripModal,
  handlSidebar,
} from 'redux/dashbbaord/dashboardSlice';
import LogosUploadModal from 'modals/logos/LogosUploadModal';
import useApiHook from 'hooks/useApiHook';

const initialValues = {
  0: {},
  1: {},
  2: {},
};

const Layout = () => {
  const routes = useProtectedRoutes();
  const { handleApiCall } = useApiHook();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { auth, dashboard } = useSelector((state) => state);
  const [isViewModal, setIsViewModal] = useState(false);
  const [logoImages, setLogoImages] = useState(initialValues);

  useEffect(() => {
    const getAd = async () => {
      const result = await handleApiCall({
        method: 'get',
        url: `/admin/logos/all`,
      });
      if (result?.status === 200) {
        result?.data?.logos?.forEach((image, index) => {
          setLogoImages((prevAdImages) => ({
            ...prevAdImages,
            [index]: { file: null, dataURL: image },
          }));
        });
      }
    };

    if (!auth?.isLogin) navigate('/login');
    else getAd();
  }, [auth?.isLogin]);

  useEffect(() => {}, [dashboard?.isSidebar]);

  useEffect(() => {
    if (window?.innerWidth < 1025) dispatch(handlSidebar(false));
    dispatch(handlPlanTripModal(false));
  }, [location]);

  return (
    <div className='ez__DashboardLayout relative w-full z-10'>
      <Header />
      <div className='ez__LayoutDiv relative flex flex-wrap w-full h-full'>
        <div
          className={`${
            dashboard?.isSidebar ? 'block' : 'hidden'
          } lg:block ez__Sidebar w-full bg-white h-full shadow-sm border-r`}
        >
          <Sidebar setIsViewModal={setIsViewModal} />
        </div>
        <div className='ez__LayoutPages w-full bg-ezMidWhite'>
          {auth?.isLogin && routes}
          {auth?.isLogin && isViewModal && (
            <LogosUploadModal
              isDefault={true}
              isViewModal={isViewModal}
              setIsViewModal={setIsViewModal}
              ModalHeader='Upload Logos'
              logoImages={logoImages}
              setLogoImages={setLogoImages}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Layout;
